import { Subject } from 'rxjs';

/**
 * Currently just provides the isAlive parameters and lifecycle for use in controllers.
 *
 * Ideally, it'd be possible to make this more composable so controllers could pick and choose
 * multiple base classes (should they ever exist) to mixin rather than potentially having
 * a giant base controller that is often only partially used.
 *
 * Perhaps something similar to how immutable.js generates classes via a function in the
 * Record API would be suitable.
 */
export abstract class MixableBaseController implements MixableBaseController {
  protected destroyed$ = new Subject<void>();

  // patches the $onDestroy and $onInit functions to set the isAlive property automatically
  constructor() {
    const childOnDestroy = (this.$onDestroy || (() => undefined)).bind(this);
    const childOnInit = (this.$onInit || (() => undefined)).bind(this);

    this.$onInit = () => {
      this.__init();
      childOnInit();
    };

    this.$onDestroy = () => {
      this.__destroy();
      childOnDestroy();
    };
  }

  private __init() {}

  private __destroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}

// seems redundant I know but TypeScript errors without this: https://git.io/vx881
export interface MixableBaseController {
  $onInit?();

  $onChanges?(changes: angular.IOnChangesObject);

  $onDestroy?();
}
